module.exports = __webpack_public_path__ + "static/media/Agriculture.cd77b957.png";